import React from 'react';
import cn from 'classnames';

import Channel from 'widget/components/WidgetChannel';
import { IWidgetChannels } from 'widget/entities/config';

import styles from './WidgetMobileChannels.module.scss';

export type WidgetMobileChannelsProps = {
  channels?: IWidgetChannels;
  className?: string;
};

const WidgetMobileChannels: React.FC<WidgetMobileChannelsProps> = ({
  channels,
  className
}) => {
  if (!channels || channels.length === 0) {
    return null;
  }

  return (
    <div className={cn(styles['channels'], className)}>
      {channels.map((channel) => (
        <div key={channel.kind}>
          <Channel channel={channel} />
        </div>
      ))}
    </div>
  );
};

export default React.memo(WidgetMobileChannels);
